import React, { useState } from 'react';

const AccordionItem = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={`accordion-item border-b ${isOpen ? 'active' : ''}`}>
            <div className="accordion-item-header p-6 flex justify-between items-center" onClick={toggleAccordion}>
                <h4 className="font-semibold text-lg">{title}</h4>
                <span className="accordion-arrow text-2xl" style={{ color: '#D4AF37' }}>&darr;</span>
            </div>
            <div className="accordion-item-body">
                <div className="space-y-4 text-gray-700">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default AccordionItem;